import type {z} from "zod";

import {
  ContactInputFields,
  PhoneNumberInput,
} from "@project/sdk/engineering/supplier-components-zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const fields = ContactInputFields.shape;

export const editSupplierContactNameSchema = requiredStringSchema(
  fields.name,
  contactFieldLabelIds.name,
);
export const editSupplierContactEmailSchema = fields.email.or(zod.literal(""));

const editSupplierContactFormFieldsSchema = zod.object({
  name: editSupplierContactNameSchema,
  description: fields.description,
  email: editSupplierContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const editSupplierContactFormSchema = editSupplierContactFormFieldsSchema.superRefine(
  (value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }
    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({code: "custom", message: "Phone prefix is required", path: ["phonePrefix"]});
    }
  },
);
export type EditSupplierContactFormPayload = z.output<typeof editSupplierContactFormSchema>;

export const draftEditSupplierContactFormSchema = editSupplierContactFormFieldsSchema.partial();
export type DraftEditSupplierContactFormPayload = z.output<
  typeof draftEditSupplierContactFormSchema
>;
